import styled from"../styled-components";export default styled.section`
  flex: 1 0 auto;
  position: relative;
`;